<template>
  <div>
    <van-field
      v-model="telCode"
      name="验证码"
      label-width="2rem"
      placeholder="请输入验证码"
      :rules="[{ required: true, message: '' }]"
    >
      <template #label>
        <span class="ts">*</span>
        验证码
      </template>
      <template #button>
        <van-button
          size="mini"
          :disabled="count ? true : false"
          @click="getCode"
          native-type="button"
          type="primary"
          color="#4967B7"
          >{{ count ? `${count}秒后再次发送` : "获取验证码" }}</van-button
        >
      </template>
    </van-field>
    <div class="loginP"
         v-if="showSlider"></div>
    <div class="islider"
         v-if="showSlider">
      <slider @getImg="getImg"
                @validImg="validImg"
                @close="onClose"
                :log="true"></slider>
    </div>
<!--    <van-dialog-->
<!--      v-model="imgValidateShow"-->
<!--      title="请输入图片验证码"-->
<!--      show-cancel-button-->
<!--      :lazy-render="false"-->
<!--      confirm-button-text="提交"-->
<!--      confirm-button-color="#2693E7"-->
<!--      :beforeClose="confirmSubmit"-->
<!--    >-->
<!--      <div class="validateBox">-->
<!--        <img :src="validateImg" @click="reGetValidateImg" />-->
<!--        <van-field-->
<!--          v-model="validateValue"-->
<!--          placeholder="请输入验证码"-->
<!--          input-align="left"-->
<!--        />-->
<!--      </div>-->
<!--    </van-dialog>-->
  </div>
</template>

<script>
import Slider from './Slider.vue'
import {checkCaptcha} from "@/http";
import {Toast} from "vant";
import {rsaPublicData} from "@/views/util";
export default {
  components: {
    Slider
  },
  data() {
    return {
      telCode: "", //验证码
      //倒计时
      count: "",
      timer: null,

      validateImg: "",
      imgValidateShow: false,
      validateValue: "",
      loginValidate: {
        id: '',
        sliderCaptchaTrack: {}
      },
      showSlider: false
    };
  },
  methods: {
    checkPhone() {
      let reg = /^1[3456789]\d{9}$/;
      if (!this.$parent.$parent.form.reflectTel) {
        this.$toast.fail("请输入反映人电话");
        return false;
      } else if (!reg.test(this.$parent.$parent.form.reflectTel)) {
        // this.$toast.fail("反映人电话格式错误");
        return false;
      } else {
        return true;
      }
    },

    reGetValidateImg() {
      this.$http
          .getCheckCode({phone: rsaPublicData(this.$parent.$parent.form.reflectTel)})
          .then(res => {
            // 文件数据
            // const blob = new Blob([res]);
            this.validateImg = res;
            this.imgValidateShow = true;
          });
    },

    confirmSubmit(action, done) {
      if (action === "confirm") {
        if (this.validateValue == "") {
          this.$toast.fail("请输入验证码!");
          done(false);
        } else {
          this.$http
              .registerYzm({
                phone: this.$parent.$parent.form.reflectTel,
                captcha: this.validateValue
              })
              .then(res => {
                if (res.result) {
                  //获取验证码成功后
                  this.getShowCode();
                  done(true);
                } else {
                  this.$toast.fail(res.message);
                  done(false);
                }
              })
              .catch(err => {
                this.validateValue = "";
                this.reGetValidateImg();
                done(false);
              });
        }
      } else {
        this.imgValidateShow = false;
        this.validateValue = "";
        done(true);
      }
    },

    getCode() {
      //验证手机号
      // if (this.checkPhone()) {
      //   this.reGetValidateImg();
      // }
      if (this.checkPhone()) {
        this.stopScroll()
        this.showSlider = true;
      }
    },
    getShowCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    // 获取滑动验证码
    getImg(callback) {
      this.$http.captchaImage().then((res) => {
        callback(res);
      }, error => {
        callback(error);
      });
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(data, id, callback) {
      this.loginValidate.sliderCaptchaTrack = data; // 手动定位返回的值
      this.loginValidate.id = id; // 后台返回的id，再传回去
      this.loginValidate.phone = rsaPublicData(this.$parent.$parent.form.reflectTel);
      //滑块验证码校验接口
      this.$http.checkCaptcha(this.loginValidate).then(res => {
        if (res.toString() === "发送成功") {
          this.getShowCode();
          this.canScroll()
          this.showSlider = false;
        } else {
          Toast.fail(res.toString());
          callback(false);
        }
      }).catch(err => {
        callback(false);
      })
    },
    onClose() {
      this.canScroll()
      this.showSlider = false;
    },
    //禁止滚动
    stopScroll(){
      let mo = function(e){e.preventDefault();};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    //取消滑动限制
    canScroll(){
      let mo = function(e){e.preventDefault();};
      document.body.style.overflow='';//出现滚动条
      document.removeEventListener("touchmove",mo,false);
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.van-cell {
  background-color: #f1f1f1;
  // padding: 10px;
  margin: 10px 0;
  // width: auto;
  border-radius: 5px;
}

.validateBox {
  padding: 20px 20px;
  display: flex;
  align-items: center;
  img {
    width: 100px;
  }
}
.loginP {
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background-color:rgba(0,0,0,0.5);
  z-index:1;
}
.islider {
  position: fixed;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
